import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import CountrySelectDropdown from "./CountrySelectDropdown";

/**
 * Shared phone number input.
 *
 * - `international` + `countryCallingCodeEditable={false}` keep the selected
 *   country's calling code in the field at all times, so picking a country
 *   always shows `+91`, `+1`, … immediately instead of only after typing.
 * - `value` is normalised because the library compares `props.value` with its
 *   own state to decide when to re-derive the country: `""` and `undefined`
 *   both mean "empty" to us but not to it, and mixing the two made it snap the
 *   country back to `defaultCountry` and drop the calling code at random.
 * - `addInternationalOption={false}` means there is always a selected country,
 *   so the field can never end up in the code-less "International" state.
 */
export default function PhoneNumberField({ value, className, ...rest }) {
  return (
    <PhoneInput
      {...rest}
      value={value || undefined}
      className={`phone-number-field${className ? ` ${className}` : ""}`}
      international
      countryCallingCodeEditable={false}
      addInternationalOption={false}
      countrySelectComponent={CountrySelectDropdown}
    />
  );
}
